module.exports = __webpack_public_path__ + "img/bg_login.18f96588.jpg";